export enum EnumTypePQRS {
  Anonymous = 1,
  NotRegistered = 3,
  Registered = 2
}